<template>
  <component :is="bodyOnly ? 'div' : 'b-card'" no-body :class="{ 'h-100 d-flex flex-column': !bodyOnly }">
    <b-card-header v-if="!bodyOnly">
      <b-card-title>Owner Updated Property</b-card-title>
    </b-card-header>

    <component :is="bodyOnly ? 'div' : 'b-card-body'" :class="{ 'flex-fill': !bodyOnly }">
      <log-property-user-update @update:total="$emit('update:total', $event)" />
    </component>
  </component>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody,
} from 'bootstrap-vue'
import LogPropertyUserUpdate from './LogPropertyUserUpdate.vue'

export default {
  components: {
    BCard, BCardHeader, BCardTitle, BCardBody, LogPropertyUserUpdate,
  },
  emits: ['update:total'],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    bodyOnly: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
